import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "-36 -24 72 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#fff\" d=\"M-36-24h72v48h-72z\"></path><g transform=\"rotate(-56.31)\"><g id=\"c\"><path id=\"a\" d=\"M-6-26H6v2H-6zm0 3H6v2H-6zm0 3H6v2H-6z\"></path><use xlink:href=\"#a\" y=\"44\"></use></g><path stroke=\"#fff\" d=\"M0 17v10\"></path><path fill=\"#cd2e3a\" d=\"M0-12a12 12 0 0 1 0 24z\"></path><path fill=\"#0047a0\" d=\"M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0z\"></path><circle cy=\"-6\" r=\"6\" fill=\"#cd2e3a\"></circle></g><g transform=\"rotate(-123.69)\"><use xlink:href=\"#c\"></use><path stroke=\"#fff\" d=\"M0-23.5v3M0 17v3.5m0 3v3\"></path></g>", 3)
  ])))
}
export default { render: render }